/**
 * @generated SignedSource<<33230919f30f9ddc2b8b0cf30fab2fc9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgenticPlanTool_richText$data = {
  get adfValue(): {
    json: AGG$JSON | null;
  } | null;
  set adfValue(value: null | undefined);
  readonly " $fragmentType": "AgenticPlanTool_richText";
};
export type AgenticPlanTool_richText$key = {
  readonly " $data"?: AgenticPlanTool_richText$data;
  readonly $updatableFragmentSpreads: FragmentRefs<"AgenticPlanTool_richText">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AgenticPlanTool_richText",
  "selections": [
    {
      "concreteType": "JiraADF",
      "kind": "LinkedField",
      "name": "adfValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "json"
        }
      ]
    }
  ],
  "type": "JiraRichText"
};

(node as any).hash = "c34d18ed795d6e63b52cb363b0113719";

export default node;
